
/**
 * Other necessary controllers
 */
var ToastrController = new (require('./ToastrController'));

var AjaxController = function(){

    (function(){

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
    })();
}

//AjaxController.prototype.handleErrors = function () {
// handling errors in Form/FormController
//}

AjaxController.prototype.send = function (url, data, success, error) {

    var self = this;

    $.ajax({
        type: 'POST',
        url: self.getOrigin() + url,
        data: data,
        dataType: 'json',

        success: function (response) {
            success(response);

            if(response.message){
	            ToastrController.showSuccess(response.message);
            }

        },

        error: function (response) {
            //var errors = response.responseJSON

            error(response);

            ToastrController.showDanger('Sorry, there were errors processing your request. Please try again later.');

        }
    });
}

//AjaxController.prototype.getFieldsData = function(form) {
//    return form.serializeArray();
//}

AjaxController.prototype.getOrigin = function(){
    if (!window.location.origin) {
        return window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
    } else {
        return window.location.origin;
    }
}

module.exports = AjaxController;
